import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import { useSolutionsOurApproachContent } from '../../../../hooks/useSolutionsOurApproachContent';
import './OurApproach.css';

const OurApproach = () => {
  const { content, isLoading } = useSolutionsOurApproachContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, steps } = content;

  return (
    <section className="our-approach">
      <div className="our-approach__inner">
        <Reveal>
          <h2 className="our-approach__title">{title}</h2>
        </Reveal>

        <div className="our-approach__steps">
          {steps.map(({ number, title: stepTitle, description }, index) => (
            <Reveal key={`${stepTitle}-${index}`} delay={index * 80} className="our-approach__step">
              <p className="our-approach__number">{number}</p>
              <h3 className="our-approach__step-title">{stepTitle}</h3>
              <p className="our-approach__step-text">{description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurApproach;
